import { PropsWithChildren, useRef } from 'react';

import BackgroundOverlayImage from 'reservations/brand/components/BackgroundOverlayImage';
import { useDynamicBackgroundHeight } from 'reservations/brand/hooks/useDynamicBackgroundHeight';

// Wraps content that needs to have background image with this wrapper
// No need to include top matter height as it is added by default
const BackgroundOverlayImageWrapper = ({
  children,
  additionalHeight
}: PropsWithChildren<{}> & { additionalHeight?: number }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const maxHeight = useDynamicBackgroundHeight(contentRef, additionalHeight);

  return (
    <>
      <BackgroundOverlayImage height={maxHeight} />
      <div ref={contentRef}>{children}</div>
    </>
  );
};

export default BackgroundOverlayImageWrapper;
